import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { loadProfileToggle } from "store/actions/authActions";
import { useDispatch } from "react-redux";
import { setLastViewedTab } from "store/actions/todoActions";
import { UserService } from "services";

function useUserService() {
  const { apiClientInstance } = useAPIClientHelper();

  const dispatch = useDispatch();

  const markIntroductionAsShown = (introductionId: string) => {
    return apiClientInstance(AuthEnums.AuthType.User).UserClient.MarkIntroductionAsShown(introductionId);
  };

  const markHelpAsShown = (helpId: string) => {
    return apiClientInstance(AuthEnums.AuthType.User).UserClient.MarkHelpAsShown(helpId);
  };

  const signEula = () => {
    return apiClientInstance(AuthEnums.AuthType.User).UserClient.SignEula();
  };

  const suspendEulaSigning = () => {
    return apiClientInstance(AuthEnums.AuthType.User).UserClient.SuspendEulaSigning();
  };

  const getUploadedReceiptCount = () => {
    return apiClientInstance(AuthEnums.AuthType.User)
      .UserClient.GetUploadedReceiptCount()
      .then((res) => res.data);
  };

  const loadProfileToggleAsync = () => {
    return new Promise<WintSuperkollAPIModel.ProfileToggles>((resolve) => {
      UserService.getProfileToggles().then((res) => {
        dispatch(loadProfileToggle(res.data));
        resolve(res.data);
      });
    });
  };

  const loadLastViewedTab = () => {
    UserService.getDefaultTodoGroupType().then((result) => {
      dispatch(setLastViewedTab(result.data));
    });
  };

  const updateLastViewedTab = (tab: WintSuperkollAPIModel.TodoGroupType) => {
    UserService.updateDefaultTodoGroupType(tab);
    dispatch(setLastViewedTab(tab));
  };

  return {
    markIntroductionAsShown,
    markHelpAsShown,
    signEula,
    suspendEulaSigning,
    getUploadedReceiptCount,
    loadProfileToggleAsync,
    loadLastViewedTab,
    updateLastViewedTab,
  };
}

export default useUserService;
